export default {
  components: {

  },
  props: {
    screen:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      url:{
        GetSingleMsg: SZH.assets.api + '/Custom/GetSingleMsg',
      },
      show:false,
      msg:''
    }
  },
  methods: {
    toList(){
      this.$router.push({
        path: '/Menu/Products',
      })
    },
    getMsgNew(){
      var self = this;
      self.$http.post(self.url.GetSingleMsg,{

      }).then(result => {
        if (result.state == true) {
          self.show = result.data.IsSingle;
          self.msg = result.data.SingleMsg;
          if(self.show){
            self.open(self.msg);
          }
        } else {
          self.show =false
        }
      },() => {
      });
    },
    open(msg) {
      this.$confirm(msg, '提示', {
        confirmButtonText: '去个人中心',
        cancelButtonText: '取消',
        type: 'warning',
        center:true
      }).then(() => {
        this.$router.push({
          path: '/My/myMember'
        })
      }).catch(() => {

      });
    }
  },
  created() {
  },
  mounted() {
    this.getMsgNew();
  },
  computed: {

  },
  watch: {
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Home.js